"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useDelayedRender = _interopRequireDefault(require("../../hooks/useDelayedRender"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DelayedWrapper = function DelayedWrapper(_ref) {
  var delayMs = _ref.delayMs,
      children = _ref.children;
  return (0, _useDelayedRender["default"])(delayMs)(function () {
    return children;
  });
};

DelayedWrapper.propTypes = {
  delayMs: _propTypes["default"].number.isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = DelayedWrapper;
exports["default"] = _default;